var _rect, _circle, _circle2, _circle3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.653099,
    y: 4.56326,
    width: 10.6925,
    height: 6.60917,
    rx: 2.69473,
    stroke: "#587e85",
    strokeWidth: 0.974167,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.06706,
    cy: 7.86784,
    r: 1.16667,
    fill: "#587e85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.79948,
    cy: 7.86784,
    r: 1.16667,
    fill: "#587e85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.93425,
    cy: 1.33366,
    r: 1.16667,
    fill: "#587e85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.41602,
    y: 2.1377,
    width: 0.974167,
    height: 2.01149,
    fill: "#587e85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatIcon);
export default __webpack_public_path__ + "static/media/ai-chat-icon.e46f7aa653d3e1c75a99b154bc51e52c.svg";
export { ForwardRef as ReactComponent };